import { isDisplayMenuItem } from "models/menu/menu";
import {
  DisplayMenuItem,
  DisplayMenuSection,
  TypeDisplayMenuOptionGroupOptions,
  TypeDisplayMenuSections,
} from "models/menu/menuContentsReducer";

const sectionHasFoodSelected = (section: DisplayMenuSection): boolean =>
  Object.values(section.options).some((option) => {
    if (isDisplayMenuItem(option)) {
      if (option.food_id) {
        return true;
      }
      return Object.values(option.side_option_groups ?? {}).some(
        sectionHasFoodSelected,
      );
    }
    return sectionHasFoodSelected(option);
  });

export const isMenuItemMissingFood = (item: DisplayMenuItem): boolean => {
  if (item.food_id) {
    return false;
  }
  return Object.values(item.side_option_groups ?? {}).some(
    sectionHasFoodSelected,
  );
};

export const countItemsMissingFood = (
  menuContents: TypeDisplayMenuSections,
): number => {
  let count = 0;
  const walkOptions = (options: TypeDisplayMenuOptionGroupOptions): void => {
    Object.values(options).forEach((option) => {
      if (isDisplayMenuItem(option)) {
        if (isMenuItemMissingFood(option)) {
          count += 1;
        }
        Object.values(option.side_option_groups ?? {}).forEach((group) =>
          walkOptions(group.options),
        );
      } else {
        walkOptions(option.options);
      }
    });
  };
  Object.values(menuContents).forEach((section) =>
    walkOptions(section.options),
  );
  return count;
};

const filterSectionOptions = (
  section: DisplayMenuSection,
): DisplayMenuSection => {
  const filteredOptions: TypeDisplayMenuOptionGroupOptions = {};
  Object.entries(section.options).forEach(([uuid, option]) => {
    if (isDisplayMenuItem(option)) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      const filteredItem = filterItem(option);
      if (filteredItem) {
        filteredOptions[uuid] = filteredItem;
      }
      return;
    }
    filteredOptions[uuid] = filterSectionOptions(option);
  });
  return { ...section, options: filteredOptions };
};

const filterItem = (item: DisplayMenuItem): DisplayMenuItem | null => {
  const filteredGroups: TypeDisplayMenuSections = {};
  Object.entries(item.side_option_groups ?? {}).forEach(([uuid, group]) => {
    const filteredGroup = filterSectionOptions(group);
    if (Object.keys(filteredGroup.options).length > 0) {
      filteredGroups[uuid] = filteredGroup;
    }
  });
  if (!item.food_id && Object.keys(filteredGroups).length === 0) {
    return null;
  }
  return { ...item, side_option_groups: filteredGroups };
};

export const filterSkippableMenuItems = (
  menuContents: TypeDisplayMenuSections,
): TypeDisplayMenuSections => {
  const result: TypeDisplayMenuSections = {};
  Object.entries(menuContents).forEach(([uuid, section]) => {
    result[uuid] = filterSectionOptions(section);
  });
  return result;
};
